import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
`;

export const Wrapper = styled.section`
    display: flex;
    width: 100%;
    justify-content: end;
    align-items: center;
    flex-direction: row;
    gap: 16px;
    padding: 16px 16px 16px 0;

    @media (min-width: 1200px) {
      min-width: 400px;
    }
`;

export const TextInfo = styled.span`
    //font-family: Roboto;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.2px;
    color: ${({ theme }) => theme.colors.text.primary};
`;

export const Spinner = styled.svg`
  width: 20px;
  height: 20px;
  animation: ${rotate} 2s linear infinite;
  
  & .path {
    stroke: ${({ theme }) => theme.colors.accent.primary};
    stroke-linecap: round;
    animation: ${dash} 1.5s ease-in-out infinite;
  }
`;
